// ============================================================================
// CENTRAL SITE CONFIGURATION — edit content here, not inside components.
// ============================================================================

// --- External organization websites (production configured) -----------------
export const EXTERNAL_URLS = {
  ATS: "https://atmasammantech.com/",
  ASAI: "https://www.atmasammanschoolofai.com/",
  AIMT: "https://aimtindia.in/",
};

// --- Contact & communication -------------------------------------------------
export const CONTACT = {
  phoneDisplay: "+91 75055 32934",
  phoneDigits: "917505532934",
  primaryEmail: "Director@atmasamman.com",
  businessEmail: "support@atmasamman.com",
  adminEmail: "asgatsitsolutions@gmail.com",
  address: "98 Shivpuri, Near DAV Degree College, Reliance Smart Point, Bulandshahr 203001, UP, India",
  addressShort: "Bulandshahr, Uttar Pradesh, India",
  hours: "Mon – Sat, 10:00 AM – 7:00 PM IST",
  website: "www.atmasamman.com",
};

// --- WhatsApp ----------------------------------------------------------------
export const WHATSAPP = {
  number: "917505532934",
  messages: {
    default: "Hello Atmasamman Group, I would like to know more about your organizations and services.",
    foundation: "Hello, I would like to know more about Atmasamman Foundation.",
    asai: "Hello, I would like to know more about ASAI.",
    ats: "Hello, I would like to know more about ATS | IT Solutions.",
    aimt: "Hello, I would like to know more about AIMT.",
  },
};

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP.number}?text=${encodeURIComponent(msg || WHATSAPP.messages.default)}`;

// --- Social media (only rendered when a URL is present) ----------------------
export const SOCIAL = {
  linkedin: "",
  instagram: "",
  facebook: "https://www.facebook.com/AtmaSammanGroup/",
  youtube: "https://www.youtube.com/@AtmasammanTech",
  x: "",
};

// --- Analytics / verification (activate only when real IDs supplied) ---------
export const ANALYTICS = {
  GA_MEASUREMENT_ID: "",
  GOOGLE_SITE_VERIFICATION: "",
  META_PIXEL_ID: "",
};

// --- Logos -------------------------------------------------------------------
export const LOGOS = {
  group: "/logos/group.png",
  ats: "/logos/ats.png",
  asai: "/logos/asai.png",
  aimt: "/logos/aimt.png",
};

// --- Brand -------------------------------------------------------------------
export const BRAND = {
  name: "Atmasamman Group",
  tagline: "Building Skills. Creating Technology. Transforming Lives.",
  positioning:
    "Atmasamman Group brings together technology services, artificial intelligence and future-skills education, professional learning, higher education and social impact under one shared vision.",
};

// --- Interest categories (enquiry form) --------------------------------------
export const INTEREST_OPTIONS = [
  "Atmasamman Group",
  "ATS | IT Solutions",
  "ASAI",
  "AIMT",
  "Atmasamman Foundation",
  "Technology Services",
  "AI / DevOps / Cloud Training",
  "Higher Education",
  "Internship Opportunities",
  "Career Opportunities",
  "Business Partnership",
  "CSR / Foundation Collaboration",
  "General Enquiry",
  "Other",
];

export const USER_TYPES = [
  "Student",
  "Fresher",
  "Working Professional",
  "Business Owner",
  "Company / Organization",
  "Parent / Guardian",
  "Educational Institution",
  "NGO / Social Organization",
  "Other",
];

export const CONTACT_METHODS = ["Phone Call", "WhatsApp", "Email", "SMS"];
export const CONTACT_TIMES = ["Morning", "Afternoon", "Evening", "Any Time"];

// Interests that reveal career/education fields
export const CAREER_INTERESTS = ["Career Opportunities", "Internship Opportunities"];

// --- Organizations ecosystem -------------------------------------------------
export const ORGANIZATIONS = [
  {
    code: "ATS",
    number: "01",
    logo: LOGOS.ats,
    name: "ATS | IT Solutions",
    fullName: "Atmasamman Technology Services",
    category: "IT Services & Digital Solutions",
    description:
      "Technology services and digital solutions helping businesses build, modernize, automate and grow through reliable IT solutions.",
    highlights: ["IT Consulting", "Software Development", "Cloud", "AI & Automation", "DevOps", "Cybersecurity"],
    external: true,
    url: EXTERNAL_URLS.ATS,
    interest: "ATS | IT Solutions",
    waMessage: WHATSAPP.messages.ats,
    visitLabel: "Visit ATS | IT Solutions",
  },
  {
    code: "ASAI",
    number: "02",
    logo: LOGOS.asai,
    name: "ASAI",
    fullName: "Atmasamman School / Institute of AI",
    category: "AI & Future Skills",
    description:
      "Industry-oriented learning focused on Artificial Intelligence, DevOps, Cloud, Python, automation and emerging technologies.",
    highlights: ["Artificial Intelligence", "Generative AI", "DevOps & Cloud", "Python", "UPI & Digital Payments"],
    external: true,
    url: EXTERNAL_URLS.ASAI,
    interest: "ASAI",
    waMessage: WHATSAPP.messages.asai,
    visitLabel: "Visit ASAI",
    darkLogo: true,
  },
  {
    code: "AIMT",
    number: "03",
    logo: LOGOS.aimt,
    name: "AIMT",
    fullName: "Atmasamman Institute of Management & Technology",
    category: "Higher Education & Professional Learning",
    description:
      "Education and professional development designed to help learners build strong academic foundations and career-ready capabilities.",
    highlights: ["BCA", "MCA", "BBA", "MBA"],
    external: true,
    url: EXTERNAL_URLS.AIMT,
    interest: "AIMT",
    waMessage: WHATSAPP.messages.aimt,
    visitLabel: "Visit AIMT",
  },
  {
    code: "FOUNDATION",
    number: "04",
    logo: LOGOS.group,
    name: "Atmasamman Foundation",
    fullName: "Atmasamman Foundation",
    category: "Social Impact & Community Development",
    description:
      "An Atmasamman Group initiative focused on creating meaningful opportunities through education, skills, awareness, empowerment and community-focused programs.",
    highlights: ["Education", "Digital Literacy", "Skill Development", "Community Empowerment"],
    external: false,
    url: "/foundation",
    interest: "Atmasamman Foundation",
    waMessage: WHATSAPP.messages.foundation,
    visitLabel: "Explore Foundation",
  },
];

// --- Foundation content ------------------------------------------------------
export const FOUNDATION = {
  focusAreas: [
    { title: "Education & Learning", icon: "GraduationCap", desc: "Making quality learning and academic support more accessible to those who need it." },
    { title: "Digital Literacy", icon: "MonitorSmartphone", desc: "Helping people confidently use digital tools, the internet and everyday technology." },
    { title: "Skill Development", icon: "Wrench", desc: "Practical, employable skills that open doors to opportunity and self-reliance." },
    { title: "Youth Empowerment", icon: "Rocket", desc: "Guiding young people toward confidence, direction and future readiness." },
    { title: "Career Awareness", icon: "Compass", desc: "Awareness of career pathways, options and how to prepare for them." },
    { title: "Technology Awareness", icon: "Cpu", desc: "Introducing communities to how technology and AI shape the modern world." },
    { title: "Community Development", icon: "Users", desc: "Community-focused programs that strengthen local participation and growth." },
    { title: "Women & Community Empowerment", icon: "HeartHandshake", desc: "Encouraging participation, learning and empowerment across the community." },
  ],
  approach: [
    { step: "Awareness", desc: "Introducing people to opportunities in education, skills and technology." },
    { step: "Learning", desc: "Providing accessible learning and guidance to build a foundation." },
    { step: "Skills", desc: "Turning learning into practical, real-world capabilities." },
    { step: "Opportunity", desc: "Connecting skills to pathways for growth and progress." },
    { step: "Empowerment", desc: "Enabling individuals and communities to move forward with confidence." },
  ],
  // Real, verified initiatives only. Leave empty until supplied.
  initiatives: [],
  // Real, verified gallery images only. Leave empty until supplied.
  gallery: [],
  // Only metrics with verified values. Leave empty to hide the section.
  impact: [],
  getInvolved: [
    { title: "Volunteer With Us", icon: "HandHeart", desc: "Share your time and skills to support community programs.", interest: "CSR / Foundation Collaboration" },
    { title: "Partner With Us", icon: "Handshake", desc: "Collaborate on education, skills and awareness initiatives.", interest: "CSR / Foundation Collaboration" },
    { title: "CSR Collaboration", icon: "Building2", desc: "Align your organization's CSR goals with grassroots impact.", interest: "CSR / Foundation Collaboration" },
    { title: "Invite Us for a Community Program", icon: "CalendarHeart", desc: "Bring an awareness or skill session to your community.", interest: "CSR / Foundation Collaboration" },
    { title: "Support an Initiative", icon: "Sprout", desc: "Help us extend the reach of an ongoing focus area.", interest: "CSR / Foundation Collaboration" },
    { title: "Contact Foundation", icon: "Mail", desc: "Reach out with your idea, question or proposal.", interest: "Atmasamman Foundation" },
  ],
};

// --- Careers (real vacancies only; empty by default) -------------------------
export const CAREERS = {
  positions: [], // { id, title, organization, department, location, employmentType, experience, category, description, requirements: [] }
};

// --- Leadership (configurable, verified) -------------------------------------
export const LEADERSHIP = [
  {
    name: "Pankaj Sharma",
    role: "Founder — Atmasamman Group",
    bio: "Technology consultant, AI and digital payments expert, corporate trainer and mentor with 15+ years of industry experience, driving the vision across the Atmasamman ecosystem.",
  },
];

// --- SEO per page ------------------------------------------------------------
export const SITE_URL = "https://www.atmasamman.com";
